import { GlobalAxios } from "../axios/axios-config";
import { ICalendarSpecialtyConsultationWeb } from "../models/calendar-specialty-consultation-web";

const CALENDAR_SPECIALTY_CONSULTATION_WEB_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/CalendarSpecialtyConsultationWeb/CalendarSpecialtyConsultationWeb";

export const calendarSpecialtyConsultationWebList = (params?: any) => {
  return GlobalAxios.get<ICalendarSpecialtyConsultationWeb[]>(
    CALENDAR_SPECIALTY_CONSULTATION_WEB_ROUTE,
    {
      params: params,
      paramsSerializer: { indexes: null },
    }
  );
};
